import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-edit" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 1,
  class: "w-100 d-flex"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check" }, null, -1)
const _hoisted_6 = [
  _hoisted_5
]

import { ref } from "vue";
import { BlocklyService } from "../../biz/remote/BlocklyService";
import { MessageDialog } from "../../../framework/frontend/MessageDialog";
import { translation } from "../../lang/Translation";
interface Prop {
  project_id: string;
  title: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'TitleEdit',
  props: {
    project_id: null,
    title: null
  },
  setup(__props: any) {

const props = __props as {
  project_id: string;
  title: string;
};

const t = translation;



/**
 * タイトル編集
 */
const isEditing = ref(false);
const editingTitle = ref(props.title);
const toEdit = () => {
  isEditing.value = true;
};

const editDone = () => {
  const biz = new BlocklyService();
  biz.editTitle(props.project_id, editingTitle.value);
  MessageDialog.info(t.to("保存しました", "save_success"));
  isEditing.value = false;
};

return (_ctx: any,_cache: any) => {
  return (!isEditing.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createTextVNode(_toDisplayString(editingTitle.value) + " ", 1),
        _createElementVNode("button", {
          class: "btn btn-default btn-sm",
          onClick: toEdit
        }, _hoisted_3)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_4, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((editingTitle).value = $event)),
          class: "form-control me-2"
        }, null, 512), [
          [_vModelText, editingTitle.value]
        ]),
        _createElementVNode("button", {
          class: "btn btn-danger btn-sm",
          onClick: editDone
        }, _hoisted_6)
      ]))
}
}

})